import { apiService } from '../services/apiService';

export interface UserProfile {
    nickname: string;
    dateOfBirth: string;
    timezone: string;
    profilePictureName?: string;
}

export interface UpdateUserProfilePayload {
    nickname?: string;
    dateOfBirth?: string;
    timezone?: string;
    profilePictureFile?: string;
}

export const getImageUrl = (fileName: string): string => {
    return `${process.env.REACT_APP_IMAGE_URL}/profile_pictures/${fileName}`;
};

export const getUserProfile = async (userId: string): Promise<UserProfile> => {
    try {
        const response = apiService.responseHandler(
            await apiService.get(`user_profiles?user=${userId}`)
        );

        return response.member.length ? response.member[0] : response.member;
    } catch (error: any) {
        console.error('Failed to fetch user profile:', error);
        throw new Error(error?.message || 'Failed to fetch user profile');
    }
};

export const updateUserProfile = async (profileData: Partial<UpdateUserProfilePayload>): Promise<UserProfile> => {
    try {
        const response = apiService.responseHandler(
            await apiService.put('user_profiles/create_update/json', profileData)
        );
        
        return response.data;
    } catch (error: any) {
        console.error('Failed to update user profile:', error);
        throw new Error(error?.message || 'Failed to update user profile');
    }
};

export const userProfilesService = {
    getUserProfile,
    updateUserProfile,
};

export default userProfilesService;